import { render, staticRenderFns } from "./mintNfts_0.vue?vue&type=template&id=98421830&scoped=true"
import script from "./mintNfts_0.vue?vue&type=script&lang=js"
export * from "./mintNfts_0.vue?vue&type=script&lang=js"
import style0 from "./mintNfts_0.vue?vue&type=style&index=0&id=98421830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98421830",
  null
  
)

export default component.exports